import { AbstractControl, FormArray, FormGroup, ValidatorFn } from '@angular/forms';
import { isValidPhoneNumber } from 'libphonenumber-js';

export function phoneNumberValidator(
  countryCodeControlName: string,
  countryCodeFormControl?: AbstractControl,
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const countryCodeControl = findControl(control.root, countryCodeControlName) ?? countryCodeFormControl;
    if (control.value && countryCodeControl) {
      const isValid = isValidPhoneNumber(countryCodeControl.value + control.value);
      if (isValid) {
        return null;
      }
    }
    return { phoneValidation: true }; // Validation failed
  };
}

export function phoneWithCodeValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value) {
      const isValid = isValidPhoneNumber(control.value);
      if (isValid) {
        return null;
      }
    }
    return { phoneValidation: true }; // Validation failed
  };
}

// Recursive function to search nested controls. Must descend through FormArray nodes
// (e.g. businessOnboardingFlow.members, one FormGroup per director) as well as FormGroup
// ones - otherwise countryCode can never be found for a phone control that lives inside a
// FormArray item, and phoneNumberValidator fails validation unconditionally.
function findControl(root: AbstractControl, name: string): AbstractControl | null {
  if (!root || !name) return null;

  if (root instanceof FormGroup) {
    if (root.controls[name]) {
      return root.controls[name];
    }

    for (const key of Object.keys(root.controls)) {
      const child = root.controls[key];
      const found = findControl(child, name);
      if (found) return found;
    }
  } else if (root instanceof FormArray) {
    for (const child of root.controls) {
      const found = findControl(child, name);
      if (found) return found;
    }
  }

  return null;
}
